import React from "react";
import TemplateModal from "../../../components/template/Template.Modal";
import { ContextCart } from "../../../context/Context.Cart";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  SYMBOL_CURRENCY,
  TEXT_CANCEL,
  TEXT_DELETE,
} from "../../../utils/useConstants";
import { FunctionGetPathUrl } from "../../../utils/useFunction";
import {
  STYLE_BODY_3_REGULAR,
  STYLE_DELETE_BUSKET,
  STYLE_HEADING_3_BOLD_24_18,
  STYLE_HEADING_3_BOLD_24_18_TH,
  STYLE_PARENT_DELETE_PROGRAM,
  STYLE_SUB_TEXT_DETAIL,
  STYLE_TITLE_BOLD,
  STYLE_TITLE_SEMIBOLD,
} from "../../../utils/useStyle";
import BasketDeleteOrder from "../function/Basket.DeleteOrder";

const BusketRenderWater = ({ value, setValue, data, raw }) => {
  const { setCart, Storage } = React.useContext(ContextCart);
  const { language } = React.useContext(ContextLanguage);
  const [open, setOpen] = React.useState(false);

  return (
    <div className={`${`flex border-b border-[#D0D3E5] py-4`}`}>
      <img
        className={`shadow-none w-14 h-14 2xl:w-16 2xl:h-16 3xl:w-20 3xl:h-20 mr-4`}
        src={FunctionGetPathUrl(data?.icon_key)}
      />
      <div className={`w-full`}>
        <div className=" flex justify-between w-full">
          <div className={STYLE_TITLE_BOLD(language)}>
            {language === "TH" ? data?.name_th : data?.name_en}
          </div>
          <div className={`${STYLE_TITLE_SEMIBOLD(language)} leading-6`}>
            <span className="font-NotoSansThai">{SYMBOL_CURRENCY}</span>
            {data?.price}
          </div>
        </div>
        <div className={``}>
          <div className={language === "TH" ? `text-xs-th` : "text-xs"}>
            {language === "TH" ? data?.description_th : data?.description_en}
          </div>
        </div>
        <div className={` my-1.5 `}>
          <div
            onClick={() => {
              setOpen(true);
            }}
            className={STYLE_DELETE_BUSKET(language)}
          >
            {TEXT_DELETE[language]}
          </div>
        </div>
        <TemplateModal
          acceptText={TEXT_DELETE[language]}
          cancelText={TEXT_CANCEL[language]}
          save={() => {
            BasketDeleteOrder(setCart, data?.type, Storage, data?._id);
          }}
          showCloseButton={true}
          showSaveButton={true}
          open={open}
          setOpen={setOpen}
          panel={
            <div
              className={`${STYLE_PARENT_DELETE_PROGRAM} ${
                language === "TH" ? "font-NotoSansThai" : "font-Poppins"
              }`}
            >
              <div
                className={`${
                  language === "TH"
                    ? STYLE_HEADING_3_BOLD_24_18_TH
                    : STYLE_HEADING_3_BOLD_24_18
                } text-center h-h_30 `}
              >
                {language === "TH" ? "ลบบริการ?" : "Delete Service?"}
              </div>
              <div
                className={` py-3 md:pt-6 h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
                  language
                )}`}
              >
                {language === "TH"
                  ? "คุณต้องการลบโปรแกรมนี้ใช่ไหม?"
                  : "Are you sure you want to delete this service?"}
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default BusketRenderWater;
